import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

export function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const [err, setErr] = useState<string>("");
  const appEnabled = String(import.meta.env.VITE_APP_ENABLED).toLowerCase() === "true";

  useEffect(() => {
    const run = async () => {
      try {
        // Preserve ?next=/dashboard if present
        const params = new URLSearchParams(location.search);
        const defaultNext = appEnabled ? "/dashboard" : "/intake";
        const next = params.get("next") || defaultNext;

        // 1) If Supabase used PKCE, there will be ?code=...
        const code = params.get("code");
        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) throw error;
        } else {
          // 2) If Supabase used implicit flow, tokens are in the hash (#access_token=...)
          // supabase-js will often pick this up automatically, but we give it a tick.
          await supabase.auth.getSession();
        }

        // Store email in your localStorage format for your existing RouteGate logic
        const { data } = await supabase.auth.getUser();
        const email = data?.user?.email?.toLowerCase() || "";
        if (email) {
          localStorage.setItem("niyyah_email", email);
        }

        nav(next, { replace: true });
      } catch (e: any) {
        setErr(e?.message || "Login failed. Please try again.");
      }
    };

    run();
    }, [location.search, location.hash, nav]);


  if (err) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md w-full text-center">
          <h1 className="text-2xl font-light mb-3">Couldn’t sign you in</h1>
          <p className="text-sm text-gray-600 mb-6">{err}</p>
          <button
            onClick={() => nav("/login", { replace: true })}
            className="px-6 py-3 rounded-full bg-black text-white"
          >
            Back to login
          </button>
        </div>
      </div>
    );
  }

  return null; // or a small "Signing you in..." screen
}